"use client"
import React, { useEffect, useState } from 'react'
import EventSlider from './EventSlider';
import { EventBannerResponse, PromotionBannerResponse, SubPromotionBanner } from '@/services/dataTypes';

interface Props {
    domain: string;
    banners: EventBannerResponse[] | PromotionBannerResponse[] | SubPromotionBanner[];
    eventName: string;
}

const EventBanner = ({ domain, banners, eventName }: Props) => {
    const [hydrated, setHydrated] = useState(false)
    useEffect(() => setHydrated(true), [])

    return (
        // Added: ring-1 for crisp border, subtle shadow, and responsive margins
        <div className="relative mx-4 mt-4 overflow-hidden bg-white/50 backdrop-blur-sm rounded-2xl ring-1 ring-black/5 md:mx-8 md:mt-8 xl:mx-12 xl:mt-10 shadow-sm">
            <div className="relative w-full overflow-hidden slider-hydration-wrapper">
                <div
                    className={`transition-opacity duration-500 ease-in-out ${hydrated ? 'opacity-100' : 'opacity-0'}`}
                >
                    <EventSlider sliders={banners} domain={domain} eventName={eventName}/>
                </div>
            </div>
        </div>
    )
}

export default EventBanner